import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider, ErrorBoundary } from '@rollbar/react'
import '@reddishgreen/radcliffecomponents/styles.css'
import './index.css'
import App from './App.tsx'
import { rollbar, isRollbarEnabled } from './utils/rollbar'

const appElement = (
  <StrictMode>
    <App />
  </StrictMode>
)

createRoot(document.getElementById('root')!).render(
  isRollbarEnabled ? (
    <Provider instance={rollbar}>
      <ErrorBoundary>
        {appElement}
      </ErrorBoundary>
    </Provider>
  ) : (
    appElement
  )
)
